  //Уведомления
  const notifyTest = (() => {

    document.addEventListener('click', (evt) => {
      if (evt.target.classList.contains("notify__close")) {
        evt.target.parentNode.remove();
      }
    });

    const notifyNodeWrap = document.createElement('div');
    notifyNodeWrap.setAttribute('class','notify');
    document.body.appendChild(notifyNodeWrap);

    return ({ message, delay, success }) => {
      const buttonClose = document.createElement("button");
      buttonClose.setAttribute('class','notify__close');
      buttonClose.innerHTML = "Закрыть";

      const notifyNode = document.createElement('div');
      notifyNode.setAttribute('class','notify__item');

      if (success === false) {
        notifyNode.classList.add('notify__item--error');
      }

      notifyNode.innerHTML = message;

      notifyNode.appendChild(buttonClose);
      notifyNodeWrap.appendChild(notifyNode);

      let int = 0;

      const timer = setInterval(() => {
        int += 1;
        if (int === delay) {
          const notify = document.querySelector('.notify__item');
          if (notify) {
            notifyNodeWrap.removeChild(notify);
            clearInterval(timer);
          }
        }
      }, 1000);
    }
  })();

$(function () {

  const debounce = (fn, ms) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
      timer = null;
      fn.apply(this, args);
      }, ms);
    };
  }

  const sliderMain = $('.slider-main__list');

  if (sliderMain) {
    sliderMain.slick({
      vertical: true,
      dots: true,
      arrows: false,
      verticalSwiping: true,
      appendDots: $('.slider-main__nav'),
      responsive: [{
        breakpoint: 767,
        settings: {
        vertical: false,
          dots: true,
          arrows: false,
          verticalSwiping: false,
        }
      }]
    });

    window.addEventListener('resize', () => {
      $('.slider-main__list').slick("setPosition");
    })

  }

  var sliderLogo = $('.slider-logo__list');

  if (sliderLogo.length > 0) {
    const sliderLogoInit = () => {
      sliderLogo.not('.slick-initialized').slick({
        slidesToShow: 1,
        infinite: true,
        focusOnSelect: true,
        variableWidth: true,
        arrows: true,
        prevArrow: '<button class="slider-logo__arrow-prev"></button>',
        nextArrow: '<button class="slider-logo__arrow-next"></button>',
        responsive: [{
          breakpoint: 767,
          settings: "unslick"
        }]
      });
    }

    sliderLogoInit();

    if (window.innerWidth <= 767) {
      sliderLogo.slick("unslick");
    }
  
    window.addEventListener('resize', () => {
      if (window.innerWidth > 767) {
        sliderLogoInit();
      }
    });

    const sliderLogoOnWheel = $('.slider-logo__list')[0];
    sliderLogoOnWheel.addEventListener('wheel', (evt) => {
      evt.preventDefault();

      sliderLogoOnWheel.scrollBy({
        left: evt.deltaY < 0 ? -30 : 30,
      });
    });
  }

  const priceInput = document.querySelectorAll('.range-input');

  priceInput.forEach(item => {
    let priceGap = 1;
    const priceInputField = item.querySelectorAll('input[type="number"]'),
    progress = item.querySelector('.range-input__progress'); 
    
    const rangeInput = item.querySelectorAll('.range-input__range-fileds input');
    rangeInput.forEach(input => {
  
      progress.style.left = 100 - (rangeInput[0].max - rangeInput[0].value) / (rangeInput[0].max - rangeInput[0].min) * 100 + '%';
      progress.style.right = (rangeInput[1].max - rangeInput[1].value) / (rangeInput[1].max - rangeInput[1].min) * 100 + '%';
  
      input.addEventListener("input", (e) => {
        let minVal = parseInt(rangeInput[0].value),
        maxVal = parseInt(rangeInput[1].value);
  
        if (maxVal - minVal < priceGap) {
          if(e.target.classList.contains('range-input__range-min')) {
            rangeInput[0].value = maxVal - priceGap;
          } else {
            rangeInput[1].value = minVal + priceGap;
          }
        } else {
          priceInputField[0].value = minVal;
          priceInputField[1].value = maxVal;
          progress.style.left = 100 - (rangeInput[0].max - rangeInput[0].value) / (rangeInput[0].max - rangeInput[0].min) * 100 + '%';
          progress.style.right = (rangeInput[1].max - rangeInput[1].value) / (rangeInput[1].max - rangeInput[1].min) * 100 + '%';
        }
  
      });
    });
  
  
    priceInputField.forEach(input => {
      input.addEventListener("input", (e) => {
          let minVal = parseInt(priceInputField[0].value),
          maxVal = parseInt(priceInputField[1].value);
          if ((maxVal - minVal >= priceGap) && maxVal <= rangeInput[0].max) {
            if(e.target.classList.contains('range-input__number-min')) {
              rangeInput[0].value = minVal;
              progress.style.left = 100 - (rangeInput[0].max - rangeInput[0].value) / (rangeInput[0].max - rangeInput[0].min) * 100 + '%';
            } else {
              rangeInput[1].value = maxVal;
              progress.style.right = (rangeInput[1].max - rangeInput[1].value) / (rangeInput[1].max - rangeInput[1].min) * 100 + '%';
            }
          } 
      });
    });
  
  });

  const faqTabs = document.querySelectorAll('.faq__question');

  const handleFaqTabs = () => {
    for (let i = 0; i <= faqTabs.length; i += 1) {
      if (faqTabs[i]) {

        const handleSetHeightContent = (isResize) => {
          if (faqTabs[i].parentElement.classList.contains('open')) {
            faqTabs[i].parentElement.style = `max-height: ${faqTabs[i].nextElementSibling.offsetHeight + faqTabs[i].offsetHeight}px`;
          }

          if (isResize) {
            faqTabs[i].parentElement.classList.remove('open');
            faqTabs[i].parentElement.removeAttribute('style');
          }
        }

        handleSetHeightContent();

        window.addEventListener('resize', () => {
          handleSetHeightContent(true);
          window.removeEventListener('resize', handleSetHeightContent);
        })

        faqTabs[i].addEventListener('click',(evt) => {
          const faqTitleParent = evt.target.parentElement;
          if (faqTitleParent.classList.contains('open')) {
            faqTitleParent.classList.remove('open');
            faqTitleParent.style = `max-height: ${faqTabs[i].offsetHeight}px`;
          } else {
            faqTitleParent.classList.add('open');
            faqTitleParent.style = `max-height: ${faqTabs[i].nextElementSibling.offsetHeight + evt.target.offsetHeight}px`;
          }
        })
      }
    }
  }
  handleFaqTabs();

  setTimeout(() => {
  
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://api-maps.yandex.ru/2.1/?lang=ru_RU&amp;apikey=10f4c8ee-11c9-47ee-be37-675358036731&width=100%";
    document.querySelector('body').appendChild(script);

    script.onload = function(){
      const yandexMapInit = () => {        

        const handleCreateMap = ({ yandexMapId, placemarkCoordinates }, callback) => {
          const yandexMapContainer = document.querySelector(`#${yandexMapId}`);

          if (yandexMapContainer) {
            const myMap = new ymaps.Map(yandexMapId, {
                center: [58.564871, 49.610066],
                zoom: 16,
                controls: []
              },{
                autoFitToViewport: 'always',
                suppressMapOpenBlock: true
              });
          
              let objectsCollection = new ymaps.GeoObjectCollection(null, {
                iconLayout: 'default#image',
                iconImageSize: [20, 25],
              });

              if (placemarkCoordinates.length > 0) {

                for (let i = 0; i < placemarkCoordinates.length; i += 1) {
                  objectsCollection.add(new ymaps.Placemark(placemarkCoordinates[i].marker, {
                    hintContent: placemarkCoordinates[i].hintContent,
                  }));
                }

                myMap.geoObjects.add(objectsCollection);

                const generateMap = ({ centerCoordinates, zoom, height }) => {
                  document.querySelector(`#${yandexMapId}`).style = `height: ${height}px;`;
                  myMap.setCenter(centerCoordinates, zoom);
                  myMap.container.fitToViewport();
                };

                if (callback) {
                  callback({ myMap, yandexMapId, generateMap });
                }
              }
            }
          }
          
          handleCreateMap({
            yandexMapId: 'yandex-map',
            placemarkCoordinates: [{
              marker: [58.564761, 49.610566],
            }]
          });
      }
      ymaps.ready(yandexMapInit);
    }
  }, 500);

  //Нестандартные selectbox
  const selectbox = document.querySelectorAll('.selectbox-custom');
  const createSelectbox = ({ isFirstAtPlaceholder }, callback) => {
    
    for(let i = 0; i < selectbox.length;i++) {
      let selectWrap = document.createElement('div'); 
      selectWrap.className = "selectbox-custom";
      
      let selectedOption = document.createElement('div'); 
      selectedOption.className = "selectbox-custom__current-option";
      selectedOption.setAttribute('tabindex', '0');
  
      let ul = document.createElement('ul'); 
      ul.className = "selectbox-custom__list";
      selectbox[i].style.display = 'none';

      const currentOption = selectbox[i].querySelector('[selected]');
      if (currentOption) {
        selectedOption.innerText = currentOption.textContent;
      } else {
        selectedOption.innerText = selectbox[i].children[0].textContent;
      }
  
      for(let j = isFirstAtPlaceholder ? 1 : 0; j < selectbox[i].children.length; j++) {
        let li = document.createElement('li'); 
        li.className = "selectbox-custom__item";
        li.setAttribute('data-value', selectbox[i].children[j].value);
        li.innerText = selectbox[i].children[j].innerText;
        ul.append(li);
      }
  
      selectWrap.append(selectedOption);
      selectWrap.append(ul);
      selectbox[i].after(selectWrap);

      if (callback) {
        if (currentOption) {
          callback(currentOption.textContent);
        } else {
          callback(selectbox[i].children[0].textContent);
        }
      }
  
      ul.addEventListener('click', (evt)=> {
        if (evt.target.nodeName === 'LI') {
          selectedOption.innerText = evt.target.innerText;

          if (callback) {
            callback(evt.target.innerText);
          }

          selectbox[i].value = evt.target.getAttribute('data-value');
          evt.target.closest(".selectbox-custom__list").classList.remove("open");
          selectedOption.classList.remove("open");
          selectedOption.focus();
          
          evt.target.closest(".selectbox-custom__list").previousElementSibling.classList.add("is-selected");
        
          setTimeout(() => {
            triggerChange(selectbox[i]);
          }, 100);
        }
      });
  
      function triggerChange(element) {
        let changeEvent = new Event('change');
        element.dispatchEvent(changeEvent);
      }
  
      selectedOption.addEventListener('click', (evt) => {
        evt.target.classList.toggle("open");
        evt.target.nextSibling.classList.toggle("open");
      });
    }
  }

  createSelectbox({
    isFirstAtPlaceholder: true
  }, (currentSelectedValue) => {
    const orderFieldAddress = document.querySelector('.field-orderform-address');
    const orderFieldAddressStore = document.querySelector('.field-orderform-store');

    if (orderFieldAddress && orderFieldAddressStore) {
      const orderFieldAddressStore = document.querySelector('.field-orderform-store');
    
      if (currentSelectedValue === 'Доставка курьером по адресу') {
        orderFieldAddressStore.style = 'display: none';
        orderFieldAddress.style = 'display: block';
        orderFieldAddressStore.querySelector('select').children[0].selected = true;
      }

      if (currentSelectedValue === 'Самовывоз') {
        orderFieldAddressStore.style = 'display: block';
        orderFieldAddress.style = 'display: none';
        orderFieldAddressStore.querySelector('select').children[1].selected = true;
        orderFieldAddress.querySelector('input').value = '';
        setTimeout(() => {
          const selectCustomList = orderFieldAddressStore.querySelector('.selectbox-custom__list');
          orderFieldAddressStore.querySelector('.selectbox-custom__current-option').innerText = selectCustomList.childNodes[0].textContent;
        }, 0);
      }

      if (currentSelectedValue === 'Доставка в пункт выдачи') {
        orderFieldAddressStore.querySelector('select').children[1].selected = true;

        setTimeout(() => {
          const selectCustomList = orderFieldAddressStore.querySelector('.selectbox-custom__list');
          orderFieldAddressStore.querySelector('.selectbox-custom__current-option').innerText = selectCustomList.childNodes[0].textContent;
        }, 0);
      }
    }
  });


  //Добавление маски полям
  const inputPhone = document.querySelectorAll('.phone-mask');
  if (inputPhone.length > 0) {
    for (let i = 0; i < inputPhone.length; i += 1) {
      const mask = new IMask(inputPhone[i], {
        mask: '+7 (000) 000-00-00',
      });
    }
  }
  
  const inputBirthday = document.querySelectorAll('.date-mask');
  if (inputBirthday.length > 0) {
    for (let i = 0; i < inputBirthday.length; i += 1) {
      const mask = new IMask(inputBirthday[i], {
        mask: Date,
      });
    }
  }

//Разное ограничение строк текста в карточках новостей
  const newsCards = document.querySelectorAll('.news-item');
  if (newsCards) {

    const handleSetBigTitle = () => {

      for(let i = 0; i < newsCards.length; i+= 1) {
        const newsTitleHeight = newsCards[i].querySelector('.news-item__title').offsetHeight;
        if (newsTitleHeight <= 70 && newsTitleHeight > 45) {
          newsCards[i].classList.add('news-item--middle-title');
          newsCards[i].classList.remove('news-item--big-title');
        } else if (newsTitleHeight > 70) {
          newsCards[i].classList.add('news-item--big-title');
          newsCards[i].classList.remove('news-item--middle-title');
        } else {
          newsCards[i].classList.remove('news-item--big-title');
          newsCards[i].classList.remove('news-item--middle-title');
        }
      }
    }

    handleSetBigTitle();
    window.addEventListener('resize', handleSetBigTitle);
  }

  //Пользовательские данные в личном кабинете
  const handleSetInputEvents = (inputs, callbackForSendAjax) => {

    //Проверка корректности email
    const handleValidateEmail = (email) => {
      let isValidEmail = true;

      if (email.length > 0) {
        isValidEmail = email.match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
      }

      return isValidEmail;
    };

    let isError = false;
    for(let i = 0; i < inputs.length; i += 1) {

      if (inputs[i].getAttribute('name') === 'email') {
        let errorEl = document.createElement("div");
        errorEl.setAttribute('class', 'field-error');
        inputs[i].after(errorEl);

        inputs[i].addEventListener('input', (evt) => {
          if (handleValidateEmail(evt.target.value)) {
            inputs[i].parentNode.querySelector('.field-error').innerText = '';
            isError = false;
          } else {
            inputs[i].parentNode.querySelector('.field-error').innerText = 'Некорректный почтовый адрес';
            isError = true;
          }
        });
      }

      inputs[i].addEventListener('focus', () => {
        if (!inputs[i].getAttribute('readonly') === null) {
          inputs[i].parentNode.classList.add('is-focused');
        }
      });
  
      inputs[i].addEventListener('blur', () => {
        inputs[i].parentNode.classList.remove('is-focused');
        const div = document.createElement('div');
        div.setAttribute('class', 'user-account__field-value')
        div.innerText = inputs[i].value;
      });

      if (callbackForSendAjax) {
        inputs[i].addEventListener('change', (evt) => {
          if (evt.target.value.length > 0 && !isError) {
            callbackForSendAjax(evt);
          }
        });
      }

    }
  }

  handleSetInputEvents(document.querySelectorAll('.user-account__input'), (evt) => {
    //Здесь получаем текущее измененное значение обновляем через Ajax.
    if (evt.target.name !== 'phone') {
      notifyTest({
        message: "Данные пользователя обновлены",
        delay: 3,
      });
    }
  });

  handleSetInputEvents(document.querySelectorAll('.order__input'));

  //Итоговая сумма товаров в корзине
  const handleSetItogSumm = () => {
    const basketRows = document.querySelectorAll('.basket__row');
    const basketItogSumm = document.querySelector('.basket__itog-summ');
    const basketItogCount = document.querySelector('.basket__itog-count');
    const basketItog = document.querySelector('.basket__itog');
    const basketHead = document.querySelector('.basket h1');
    const basketTable = document.querySelector('.basket__table');

    let itogSumma = 0;
    let countProduct = 0;
    
    for (let i = 0; i < basketRows.length; i += 1) {
      const currentPrice = +basketRows[i].querySelector('.basket__summ-value').innerText.replace(/[^\w\s!?]/g,'').replace(/\s/g, '');
      const currentCount = +basketRows[i].querySelector('.field-number__input').value;

      countProduct+=currentCount;
      itogSumma+=currentPrice;
    }

    if (basketItogCount && basketItogSumm) {
      basketItogCount.innerText = countProduct;
      basketItogSumm.innerText = new Intl.NumberFormat('ru-RU').format(itogSumma);

      console.log(basketItog);

      if (countProduct === 0 || itogSumma === 0) {
        basketItog.innerText = '';
        basketTable.innerHTML = '';
        basketHead.innerText = 'Корзина пуста';
      }
    }
  }

  handleSetItogSumm();

  const InputCounter = document.querySelectorAll('.field-number');

  if (InputCounter) {
    for(let i = 0; i < InputCounter.length; i += 1) {
      const btnMinus = InputCounter[i].querySelector('.field-number__minus');
      const btnPlus = InputCounter[i].querySelector('.field-number__plus');

      //Считаем сумму и обновляем ее
      const handleGetSumm = (currentValue, target) => {
        const priceInput = InputCounter[i].parentNode.parentNode.querySelector('.basket__summ-value');
        const csrfToken = document.querySelector('[name="csrf-token"]').getAttribute('content');
        const csrfParam = document.querySelector('[name="csrf-param"]').getAttribute('content');

        if (priceInput) {
          const priceGood = priceInput.getAttribute('data-price');
          InputCounter[i].parentNode.parentNode.querySelector('.basket__summ-value').innerText = `${new Intl.NumberFormat('ru-RU').format(priceGood * currentValue)} ₽`;

          let data = {
            count: currentValue,
            good_id: target.getAttribute('data-good-id'),
          }

          data[csrfParam] = csrfToken;

            $.ajax({
              url: '/cart/count',
              type: "POST",
              dataType: 'json',
              data: data,
              success: (data) => {
                const countGoodsInBasket = document.querySelector('.header__basket-count');
                if (countGoodsInBasket) {
                  countGoodsInBasket.innerText = data;
                }

                notifyTest({
                  message: "Количество товаров обновлено успешно",
                  delay: 3,
                });
              },
              error: (data) => {
                console.log(data);
                notifyTest({
                  message: "Возникла ошибка при обновлении количества товаров",
                  success: false,
                  delay: 3,
                });
              },
            });

          handleSetItogSumm();
 
        }
      }

      InputCounter[i].parentNode.parentNode.querySelector('.basket__delete').addEventListener('click', (evt) => {
        evt.preventDefault(); 
        handleDeleteGood(evt);
      });
  
      //Используем функцию debounse, чтобы корзина обновлялась с задержкой
      const handlePostUpdateBasket = (currentValue, target) => handleGetSumm(currentValue, target);
      const delayPostUpdateBasket = debounce((currentValue, target) => handlePostUpdateBasket(currentValue, target), 500);
      
      InputCounter[i].querySelector('.field-number__input').addEventListener('input', (evt) => {
        if (evt.target.value === '0') {
          evt.target.value = 1;
        }
        delayPostUpdateBasket(evt.target.value, evt.target);
      });
    
      //Счетчик уменьшения количества
      btnMinus.addEventListener('click', (evt) => {
        let currentValue = InputCounter[i].querySelector('.field-number__input').value - 1;
        if (currentValue > 0) {
          InputCounter[i].querySelector('.field-number__input').value = currentValue;

          //Умножаем цену на количество и показываем сумму
          delayPostUpdateBasket(currentValue, evt.target);
        }
      });

      //Счетчик увелиения количества
      btnPlus.addEventListener('click', (evt) => {
        let currentValue = +InputCounter[i].querySelector('.field-number__input').value + 1;
        InputCounter[i].querySelector('.field-number__input').value = currentValue;
        
        //Умножаем цену на количество и показываем сумму
        delayPostUpdateBasket(currentValue, evt.target);
      });

    }
  }

  const handleDeleteGood = (evtCurrentBtnDelete) => {

    const btnConfirmDelete = document.querySelector('.modal-confirm__btn');

    $.fancybox.open({
      src: '#modal-delete-good',
      opts: {
        afterClose: () => {
          if (btnConfirmDelete) {
            btnConfirmDelete.removeEventListener('click', handleDeleteGoodAjax);
          }
        }
      }
    });

    const handleDeleteGoodAjax = (evt) => {
      const dataGoodId = evtCurrentBtnDelete.target.getAttribute('data-good-id');
      const csrfToken = document.querySelector('[name="csrf-token"]').getAttribute('content');
      const csrfParam = document.querySelector('[name="csrf-param"]').getAttribute('content');
  
      let data = {
        good_id: dataGoodId,
      }

      data[csrfParam] = csrfToken;

        $.ajax({
          url: '/cart/delete',
          type: "POST",
          dataType: 'json',
          data: data,
          success: (data) => {
            $.fancybox.close({
              src: '#modal-delete-good'
            });

            evtCurrentBtnDelete.target.parentNode.remove();
            const countGoodsInBasket = document.querySelector('.header__basket-count');
            if (countGoodsInBasket) {
              countGoodsInBasket.innerText = data;
            }

            notifyTest({
              message: "Товар успешно удален из корзины",
              delay: 3,
            });

            handleSetItogSumm();
          },
          error: (data) => {
            evtCurrentBtnDelete.target.parentNode.remove();
            $.fancybox.close({
              src: '#modal-delete-good'
            });

            notifyTest({
              message: "Возникли ошибки при удалении товара из корзины",
              delay: 3,
              success: false,
            });

            handleSetItogSumm();
          },
        });

      evt.target.removeEventListener('click', handleDeleteGoodAjax);
    };

    if (btnConfirmDelete) {
     btnConfirmDelete.addEventListener('click', handleDeleteGoodAjax);
    }
  };

  const btnDeleteItemFromOrder = document.querySelectorAll('.order__list-delete');

  if (btnDeleteItemFromOrder) {
    for(let i = 0; i < btnDeleteItemFromOrder.length; i += 1) {
      btnDeleteItemFromOrder[i].addEventListener('click', handleDeleteGood);
    }
  }

  //Живой поиск
  const searchLiveHistory = document.querySelector('.search-live__history');
  const searchLiveCatalog = document.querySelector('.search-live__catalog');
  const searchLiveResult = document.querySelector('.search-live__result');
  const searchLiveCategories = document.querySelector('.search-live__categories');
  const searchLiveBtnClearHistory = document.querySelector('.search-live__history-clear');

  //История поиска
  const getHistory = () => {
    let arrHistory = JSON.parse(localStorage.getItem('history')) || [];
    let history = document.querySelector('.search-live__history-list');

    if (history) {
      history.innerHTML = '';
      let arrHistoryUnique = Array.from(new Set(arrHistory.map(item => JSON.stringify(item)))).map(item => JSON.parse(item));

      for(let i = 0; i < arrHistoryUnique.length; i += 1) {
          const historyEl = document.createElement('div');
          historyEl.setAttribute('class', 'search-live__history-item');
          historyEl.innerText = arrHistoryUnique[i].request.length > 0 ? arrHistoryUnique[i].request : '';
          history.append(historyEl);
      }
    }
  }

  getHistory();

  const setHistory = (value, callback) => {
    let arrHistory = JSON.parse(localStorage.getItem('history')) || [];

    if (value.length > 0) {
        arrHistory.push({ request: value });
        let arrHistoryUnique = Array.from(new Set(arrHistory.map(item => JSON.stringify(item)))).map(item => JSON.parse(item));

        if (arrHistoryUnique.length === 6) {
            arrHistoryUnique.splice(0, 1);
        }

        localStorage.setItem('history', JSON.stringify(arrHistoryUnique));
        if (callback) {
            callback();
        }
    }
  }

  //Очищаем историю
  if (searchLiveBtnClearHistory) {
    searchLiveBtnClearHistory.addEventListener('click', () => {
      localStorage.removeItem('history');
      getHistory();
    });
  }

  const searchForm = document.querySelector('.search__form');
  const searchInput = document.querySelector('.search__input');

  if (searchForm && searchInput) {
    searchForm.addEventListener('submit', (evt) => {
      evt.preventDefault();
      window.location = `/search?q=${searchInput.value}`;
      setHistory(searchInput.value, getHistory);
    })
  }
  
  const searchFormLive = document.querySelector('.search-live__form');
  const searchLiveInput = document.querySelector('.search-live__input');

  if (searchFormLive && searchLiveInput) {
    searchFormLive.addEventListener('submit', (evt) => {
      evt.preventDefault();
      window.location = `/search?q=${searchLiveInput.value}`;
      setHistory(searchLiveInput.value, getHistory);
    })
  }

  //Показываем историю и каталог при установке фокуса
  const searchLive = document.querySelector('.search-live');  
  const handleShowCatalogAndHistory = (evt) => {
    if (searchLive) {
      searchLive.classList.add('open');
    }

    if (searchLiveHistory && searchLiveCatalog && searchLiveCategories) {
      if (evt.target.value.length < 3) {
        searchLiveResult.classList.remove('open');
        searchLiveCategories.classList.remove('open');
        searchLiveHistory.classList.add('open');
        searchLiveCatalog.classList.add('open');
      } 
    }
  }

  if (searchLiveInput) {
    searchLiveInput.addEventListener('focus', (evt) => {
      handleShowCatalogAndHistory(evt);
    });
  }
  
  const handleGetSearchResult = (evt) => {
    const searchNoFoundEl = document.querySelector('.search-live__no-found');
    if (evt.target.value.length >= 3) { 

      const handleCreateResultItem = ({ classNameItem, classNameLink, linkUrl, itemList, name, isGetCountResult }) => {
        if (!isGetCountResult) {
          itemList.innerHTML = '';
        }
        const searchResulItem = document.createElement('div');
        searchResulItem.setAttribute('class', classNameItem);

        const searchResulLink = document.createElement('a');
        searchResulLink.setAttribute('class', classNameLink);
        searchResulItem.append(searchResulLink);
        searchResulLink.textContent = name;
        searchResulLink.setAttribute('href', linkUrl);
        itemList.append(searchResulItem);
      };

      $.ajax({
        url: `/search-api?q=${evt.target.value}`,
        type: "GET",
        dataType: 'json',
        success: (data, status, headers) => {          
          const searchResultContainer = document.querySelector('.search-live__result');
          data.length > 0 && data.forEach(element => {

            if (searchNoFoundEl) {
              searchNoFoundEl.classList.remove('open');
            }

            handleCreateResultItem({
              classNameItem: 'search-live__result-item',
              classNameLink: 'search-live__result-link',
              name: element.name,
              linkUrl: `/goods/${element.id}`,
              itemList: searchResultContainer
            });
          });


          handleCreateResultItem({
            isGetCountResult: true,
            classNameItem: 'search-live__result-item',
            classNameLink: 'search-live__result-link-count',
            name: `Найден ${headers.getResponseHeader('X-Pagination-Total-Count')} товар`,
            linkUrl: `/search?q=${evt.target.value}`,
            itemList: searchResultContainer
          });

          
          $.ajax({
            url: `/search-api/categories?q=${evt.target.value}`,
            type: "GET",
            dataType: 'json',
            success: (data) => {
              const searchResultCategoriesContainer = document.querySelector('.search-live__categories-list');

              data.length > 0 && data.forEach(element => {
                handleCreateResultItem({
                  classNameItem: 'search-live__categories-item',
                  classNameLink: 'search-live__categories-link',
                  name: element.name,
                  linkUrl: `/${element.slug}`,
                  itemList: searchResultCategoriesContainer
                });
              });
              
            },
            error: (data) => {
              console.log(data);   
            }
          });


          if (data.length === 0) {
            if (searchNoFoundEl) {
              searchNoFoundEl.classList.add('open');
            }
          }
        },
        error: (data) => {
          console.log(data);   
        },
      });

      searchLiveResult.classList.add('open');
      searchLiveCategories.classList.add('open');

      //Скрываем историю и каталог
      searchLiveHistory.classList.remove('open');
      searchLiveCatalog.classList.remove('open');
    } else {

      searchNoFoundEl.classList.remove('open');

      //Показываем историю и каталог
      searchLiveHistory.classList.add('open');
      searchLiveCatalog.classList.add('open');

      //Скрываем результаты поиска и категории
      searchLiveResult.classList.remove('open');
      searchLiveCategories.classList.remove('open');
    }
  }

  const delayGetSearchResult = debounce(handleGetSearchResult, 500);

  if (searchInput) {
    searchInput.addEventListener('focus', (evt) => {
      handleShowCatalogAndHistory(evt);
    });
    searchInput.addEventListener('input', (evt) => delayGetSearchResult(evt));
  }

  if (searchLiveInput) {
    searchLiveInput.addEventListener('input', (evt) => delayGetSearchResult(evt));
  }

  //Клик за пределами поиска
  document.addEventListener('click', (evt) => {
    const header = document.querySelector('.header');
    const userPanel = document.querySelector('.user-panel');
    if (searchLive && header && userPanel) {
      if (searchLive.contains(evt.target) 
      || header.contains(evt.target) 
      || userPanel.contains(evt.target)) return;
  
      searchLive.classList.remove('open');
    }
  }, false);   


  //Показываем поиск при помощи нижней панели
  const searchLinkPanel = document.querySelector('.user-panel__link--search');

  if (searchLinkPanel) {
    searchLinkPanel.addEventListener('click', (evt) => {
      evt.preventDefault();
      if (searchLive) {
        if (searchLive.classList.contains('open')) {
          searchLive.classList.remove('open');
          document.body.classList.remove('no-scroll');
          searchLinkPanel.classList.remove('active');
        } else {
          document.body.classList.add('no-scroll');
          searchLive.classList.add('open');
          searchLinkPanel.classList.add('active');
          searchLiveInput.focus();
        }
      }
    })
  }

  document.addEventListener('click', (evt) => {
    if (evt.target.classList.contains('search-live__history-item')) {

      if (searchInput && searchLiveInput) {
        searchInput.value = evt.target.innerText;
        searchLiveInput.value = evt.target.innerText;
        
        let inputEvent = new Event("input");
        searchInput.dispatchEvent(inputEvent); 
        searchLiveInput.dispatchEvent(inputEvent); 
      }
    }
  });

  //Переключение форм авторизации, регистрации и восстановления пароля
  const formUserAuth = document.querySelector('.form-user-auth');
  const formUserReg = document.querySelector('.form-user-reg');
  const formUserRecovery = document.querySelector('.form-user-recovery');

  if (formUserAuth && formUserReg && formUserRecovery) {
    document.addEventListener('click', (evt) => {
      if (evt.target.classList.contains('form-user__btn-reg')) {
        formUserReg.classList.add('open');
        formUserAuth.classList.remove('open');
        formUserRecovery.classList.remove('open');
      }

      if (evt.target.classList.contains('form-user__btn-login')) {
        formUserAuth.classList.add('open');
        formUserReg.classList.remove('open');
        formUserRecovery.classList.remove('open');
      }

      if (evt.target.classList.contains('form-user__btn-recovery')) {
        formUserRecovery.classList.add('open');
        formUserAuth.classList.remove('open');
        formUserReg.classList.remove('open');
      }
    });
  }  

const bigMenuShowBtn = document.querySelector('.search__btn-catalog');
const bigMenuBurgerShowBtn = document.querySelector('.burger');
const bigMenu = document.querySelector('.big-menu');
const bigMenuList = document.querySelector('.big-menu__list');
const navTopList = document.querySelector('.nav-top__list');

if (bigMenuShowBtn && bigMenu && navTopList && bigMenuList && bigMenuBurgerShowBtn) {
  const nav = navTopList.cloneNode(true);
  const btnClose = document.querySelector('.big-menu__btn-close');

  nav.classList.replace('nav-top__list','big-menu__list-bottom');
  for (let i = 0; i < nav.children.length; i += 1) {
    nav.children[i].classList.replace('nav-top__item','big-menu__bottom-item');

    if (nav.children[i].children[0]) {
      nav.children[i].children[0].classList.replace('nav-top__link', 'big-menu__bottom-link')
    }
  }

  bigMenuList.after(nav);

  const handleShowMenu = () => {
    bigMenu.classList.toggle('open');
    bigMenuShowBtn.classList.toggle('open');
    document.body.classList.toggle('no-scroll');
  }

  const handleHideMenu = () => {
    if (bigMenu.classList.contains("open") && bigMenuShowBtn.classList.contains("open")) {
      bigMenu.classList.remove('open');
      bigMenuShowBtn.classList.remove('open');
      document.body.classList.remove('no-scroll');
    }
  }
  bigMenuShowBtn.addEventListener('click', handleShowMenu);
  bigMenuBurgerShowBtn.addEventListener('click', handleShowMenu);
  btnClose.addEventListener('click', handleHideMenu);

  document.addEventListener('click', (evt) => {
      if (bigMenuShowBtn.contains(evt.target) || btnClose.contains(evt.target) || bigMenuBurgerShowBtn.contains(evt.target) || bigMenu.contains(evt.target)) return;
      handleHideMenu();
  }, false);   
}

  const brandsList = document.querySelector('.filter-catalog__brands');

  if (brandsList) {
    brandsList.addEventListener('wheel', (evt) => {
      evt.preventDefault();
    
      brandsList.scrollBy({
        left: evt.deltaY < 0 ? -30 : 30,
      });
    });
  }

  //Перемещение заголовка в фильтрах для мобильной версии
  const filterCatalogTitle = document.querySelector('.filter-catalog__title');
  const filterCatalogForm = document.querySelector('.filter-catalog__form');

  if (filterCatalogTitle && filterCatalogForm) {
    const filterCatalogTitleClone = filterCatalogTitle.cloneNode(true);
    filterCatalogTitleClone.classList.replace('filter-catalog__title', 'filter-catalog__title-mobile');
    filterCatalogForm.before(filterCatalogTitleClone);
  }

  const filterBtnShow = document.querySelector('.filter-show__btn');
  const filterCatalog = document.querySelector('.filter-catalog');
  const filterCatalogBtnClose = document.querySelector('.filter-catalog__btn-close');

  if (filterBtnShow && filterCatalog && filterCatalogBtnClose) {
    filterBtnShow.addEventListener('click', () => {
      filterCatalog.classList.add('open');
      document.body.classList.add('no-scroll');
    });

    filterCatalogBtnClose.addEventListener('click', () => {
      filterCatalog.classList.remove('open');
      document.body.classList.remove('no-scroll');
    });
  }

  const checkbox = document.querySelectorAll('input[type="checkbox"]');

  for(let i = 0; i < checkbox.length; i += 1) {
    if (checkbox[i].parentNode.nodeName === 'LABEL') {
      checkbox[i].parentNode.setAttribute('class', 'checkbox-custom')
      const checkCustom = document.createElement('span');
      checkCustom.setAttribute('class', 'checkbox-check');
      
      if (checkbox[i].parentNode.children.length === 1) {
        checkbox[i].parentNode.append(checkCustom);
      }
    }
  }


  document.addEventListener('click', (evt) => {
    if (evt.target.classList.contains('catalog-card__btn-to-cart') || evt.target.classList.contains('product-card__btn-to-cart')) {
      evt.preventDefault();
      if (evt.target.getAttribute('data-good-id')) {
        const dataGoodId = evt.target.getAttribute('data-good-id');
        const csrfToken = document.querySelector('[name="csrf-token"]').getAttribute('content');
        const csrfParam = document.querySelector('[name="csrf-param"]').getAttribute('content');

        let data = {
          good_id: dataGoodId,
        }

        data[csrfParam] = csrfToken;

        $.ajax({
          url: '/cart/add',
          type: "POST",
          dataType: 'json',
          data: data,
          success: (data) => {
            const countGoodsInBasket = document.querySelector('.header__basket-count');
            if (countGoodsInBasket) {
              countGoodsInBasket.innerText = data;
            }

            notifyTest({
              message: "Товар успешно добавлен в корзину",
              delay: 3,
            });
          },
          error: (data) => {
            console.log(data);
            notifyTest({
              message: "Возникли ошибки при добавлении товара в корзину",
              success: false,
              delay: 3,
            });
          },
        });
      }
    }
  })

});